import { FC, ReactNode, SVGProps } from 'react';

export interface SidebarIconProps extends Omit<SVGProps<SVGSVGElement>, 'ref'> {
  /** Rozmiar ikony w px (szerokość = wysokość). Domyślnie 18, jak ikony lucide w menu. */
  size?: number;
  children?: ReactNode;
}

/**
 * Wspólna powłoka line-art dla ikon sidebara. Zaprojektowana tak, by być
 * „drop-in" zgodna z ikonami `lucide-react` używanymi w `menuConfig`:
 * `viewBox 0 0 24 24`, `stroke="currentColor"`, `strokeWidth 2`, zaokrąglone
 * końce. Dzięki `currentColor` ikona dziedziczy kolor stanu (domyślny / hover /
 * aktywny) z kaskady w `Sidebar.styled.ts`, więc poprawnie bieli się na ciemnym
 * teal tle menu i rozjaśnia po najechaniu.
 *
 * Stylistyka (subtelny, „żywy" line-art) jest celowo spójna z animowanymi
 * ilustracjami pustych stanów (`TableEmptyState`) — te same motywy przewodnie,
 * tylko zdestylowane do czytelnej formy w skali 16–20px.
 */
export const SidebarIconBase: FC<SidebarIconProps> = ({
  size = 18,
  children,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    {children}
  </svg>
);
